// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event definition: https://pap.pp.dropbox.com/#/events/3802
import type { PAPEventGeneric } from "../base/event";
import type { DashSurface } from "../enums/dash_surface";
import type { DashActionSurface } from "../enums/dash_action_surface";

// Event_name: 'shown.dash_invite_modal_button'
// Description: Showing button that opens dash team invite modal and form on the surface
// Owner: otc-growth
export type Shown_DashInviteModalButton = PAPEventGeneric<
  'dash',
  'shown',
  'dash_invite_modal_button',
  {
    // Which Dash surface (web, desktop, or browser extension) the event originated from.
    dashSurface?: DashSurface;
    // The surface in which an action was taken on Dash.
    // Note: serp and search_result_page are the same thing, but we're only using serp moving forward.
    dashActionSurface?: DashActionSurface;
    // Boolean event property that is set to true for Dash for Business (dfb) users.
    isDfbUserV2?: boolean;
    // This boolean field indicates if the user is a team admin or not
    isTeamAdmin?: boolean;
  }
>;

export function PAP_Shown_DashInviteModalButton(properties?: Shown_DashInviteModalButton['properties']): Shown_DashInviteModalButton {
  return <Shown_DashInviteModalButton>{
    class: 'dash',
    action: 'shown',
    object: 'dash_invite_modal_button',
    properties,
  };
}
